import Button from './Button';
import Themed from './themed/ThemedButton';
import themes from "./themed/themes"

export const ThemedButton = Themed;
export const getTheme = themes;

export default Button;
